<template>
  <div class="charge_wallet_wrapper">
    <div class="charge_wallet_card">
      <div class="card_header">
        <i class="fal fa-wallet"></i>
        <h3>{{ $t("PLACEHOLDERS.charge_wallet") }}</h3>
      </div>

      <div class="card_body">
        <form @submit.prevent="submitChargeRequest">
          <div class="row">
            <!-- Amount Input -->
            <base-input
              col="12"
              type="number"
              :placeholder="$t('PLACEHOLDERS.charge_amount')"
              v-model.number="chargeAmount"
              required
              min="1"
            />

            <div class="col-12">
              <p class="info_text">
                <i class="fal fa-info-circle"></i>
                {{ $t("PLACEHOLDERS.charge_wallet_info") }}
              </p>
            </div>
          </div>

          <div class="buttons_wrapper">
            <button
              type="submit"
              class="charge_btn"
              :disabled="isSubmitting || !chargeAmount"
            >
              <i class="fal fa-credit-card"></i>
              {{ $t("BUTTONS.proceed_to_payment") }}
            </button>
            <button
              type="button"
              class="cancel_btn"
              @click="$router.push('/wallet/transactions')"
              :disabled="isSubmitting"
            >
              <i class="fal fa-times"></i>
              {{ $t("BUTTONS.cancel") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChargeWallet",

  data() {
    return {
      chargeAmount: null,
      isSubmitting: false,
    };
  },

  methods: {
    async submitChargeRequest() {
      if (!this.chargeAmount || this.chargeAmount <= 0) {
        this.$message.error(this.$t("MESSAGES.enter_valid_amount"));
        return;
      }

      this.isSubmitting = true;

      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("steps", this.chargeAmount);

      try {
        let res = await this.$axios({
          method: "POST",
          url: "wallet-charge",
          data: REQUEST_DATA,
        });

        this.isSubmitting = false;

        const paymentData =
          res?.data?.payment_url || res?.data?.data?.payment_url;
        const invoiceURL =
          paymentData?.invoiceURL ||
          paymentData?.invoiceUrl ||
          res?.data?.invoiceURL ||
          res?.data?.invoiceUrl;

        if (invoiceURL) {
          window.location.href = invoiceURL;
          return;
        }

        this.$message.success(
          res.data.message || this.$t("MESSAGES.wallet_charged_successfully")
        );
        this.$router.push("/wallet/transactions");
      } catch (error) {
        this.isSubmitting = false;
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.someErrorOccurred")
        );
      }
    },
  },
};
</script>

<style scoped lang="scss">
.charge_wallet_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  padding: 20px;

  .charge_wallet_card {
    background: white;
    border-radius: 20px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    max-width: 600px;
    width: 100%;
    overflow: hidden;

    .card_header {
      background: #1b706f;
      color: white;
      padding: 40px 30px;
      text-align: center;

      i {
        font-size: 64px;
        margin-bottom: 15px;
        display: block;
      }

      h3 {
        margin: 0;
        font-size: 28px;
        font-weight: 700;
      }
    }

    .card_body {
      padding: 40px 30px;

      .info_text {
        background: #f8f9fa;
        padding: 15px;
        border-radius: 10px;
        color: #6c757d;
        display: flex;
        align-items: center;
        gap: 10px;
        margin-top: 10px;

        i {
          font-size: 20px;
          color: #1b706f;
        }
      }

      .buttons_wrapper {
        display: flex;
        gap: 15px;
        margin-top: 30px;

        button {
          flex: 1;
          padding: 15px 30px;
          border: none;
          border-radius: 10px;
          font-weight: 600;
          font-size: 16px;
          cursor: pointer;
          transition: all 0.3s;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;

          &.charge_btn {
            background: #1b706f;
            color: white;

            &:hover:not(:disabled) {
              transform: translateY(-2px);
              box-shadow: 0 6px 20px #1b706f;
            }

            &:disabled {
              opacity: 0.5;
              cursor: not-allowed;
            }
          }

          &.cancel_btn {
            background: #e9ecef;
            color: #495057;

            &:hover:not(:disabled) {
              background: #dee2e6;
            }

            &:disabled {
              opacity: 0.5;
              cursor: not-allowed;
            }
          }
        }
      }
    }
  }
}
</style>
